import { useMutation } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { MutationConfig, queryClient } from '@/src/lib/react-query/react-query';

import { getFilesQueryKey } from './getFiles';
import { getFoldersQueryKey } from './getFolders';
import { getRootFilesQueryKey } from './getRootFiles';
import { getTrashQueryKey } from './getTrash';

import { LibraryItemIdsVersionedDTO } from '../types';

const url = `${PREFIX_URL}/library/modify-versioned`;

type MarkDeleteResponse = {
  'conflict-results': any[];
  'error-results': any[];
  'success-results': any[];
};
type MarkDeleteDTO = {
  itemIdsVersioned: LibraryItemIdsVersionedDTO;
  inTrash: boolean;
};

export const markDelete = ({
  itemIdsVersioned,
  inTrash,
}: MarkDeleteDTO): Promise<MarkDeleteResponse> => {
  return axios.put(url, { items: itemIdsVersioned, 'in-trash': inTrash });
};

type UseMarkDeleteOptions = {
  config?: MutationConfig<typeof markDelete>;
};

export const useMarkDelete = ({ config }: UseMarkDeleteOptions = {}) => {
  return useMutation({
    ...config,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: getFilesQueryKey.list });
      queryClient.invalidateQueries({ queryKey: getFoldersQueryKey.list });
      queryClient.invalidateQueries({ queryKey: getTrashQueryKey.list });
      queryClient.invalidateQueries({ queryKey: getRootFilesQueryKey.list });
    },
    mutationFn: (props) => markDelete(props),
  });
};
